<template>
  <v-combobox
    :value="initialValue"
    :disabled="disabled"
    :items="engines"
    :label="label"
    @change="handleChange"
    dense
    filled
    item-disabled="in_use_set"
    item-text="name"
    item-value="name"
  >
  </v-combobox>
</template>

<script>
export default {
  name: 'EngineSelector',
  props: {
    onChange: {
      type: Function,
      required: true,
      default: () => null
    },
    engines: {
      type: Array,
      default: [],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowCreation: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: 'Selecione ou digite o nome do novo motor'
    },
    initialValue: {
      type: String,
      default: undefined
    }
  },
  methods: {
    handleChange(value) {
      let result = null

      if (value && value.name) result = value.name
      if (!result && this.allowCreation) result = value

      return this.onChange(result)
    }
  }
}
</script>
